// Template names are the provider's identifiers, not labels. WhatsApp constrains them to
// /^[a-z][a-z0-9_]*$/, so every one arrives lower-cased and underscore-separated
// (`welcome_message_2`), which reads as machine output in a UI. This turns it into a title
// ("Welcome Message 2") for display.
//
// DISPLAY ONLY. The raw `name` is what identifies the template to CEQUENS and Meta, and an
// approved template's name is frozen — a send addressed to "Welcome Message 2" would simply
// fail to find a template. Never feed the output of this back into a request payload, a
// lookup key, or anything persisted.

/**
 * A template's provider name as a human-readable title.
 *
 * `welcome_message_2` → `Welcome Message 2`
 *
 * Runs of underscores collapse to one space and the ends are trimmed, so a name like
 * `__promo__offer` does not come back padded with blanks. A segment that is already
 * capitalised or is purely numeric is left as it is rather than being forced through
 * lower-case, which keeps an acronym like `KYC` intact instead of rendering it "Kyc".
 */
export function formatTemplateName(name?: string | null): string {
  if (!name) return '';

  return String(name)
    .split(/_+/)
    .filter(Boolean)
    .map((word) => (/[a-z]/.test(word) ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ')
    .trim();
}
